import { ArrowButton } from "../components/Buttons";
import { MaskLines } from "../components/Reveal";

const NotFound = () => (
  <div data-testid="not-found-page" className="bg-bottle-green text-cream min-h-screen flex items-center">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-40 w-full">
      <span className="label text-cream/55">Error 404</span>
      <h1 className="mt-6">
        <MaskLines
          lines={["Page not found."]}
          lineClass="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.9] text-cream"
        />
      </h1>
      <p className="font-sans text-base md:text-lg text-cream/70 leading-relaxed max-w-xl mt-8">
        The page you're looking for doesn't exist or has moved. Let's get you back to something meaningful.
      </p>
      <div className="flex flex-wrap gap-4 mt-10">
        <ArrowButton to="/" variant="light" testid="notfound-home">Back to Home</ArrowButton>
        <ArrowButton to="/contact" variant="ghostLight" testid="notfound-contact">Contact Us</ArrowButton>
      </div>
    </div>
  </div>
);

export default NotFound;
